// define custom elements ir-signup-form
class IrSignupForm extends HTMLElement {
  constructor() {
    super();
    this.signupEndpoint = '/apps/indeks-retail-bc/proxy/membership/signup';
    this.signupRetailerEndpoint = '/apps/indeks-retail-bc/proxy/membership/finalize-signup';
    this.signupB2bEndpoint = '/apps/indeks-retail-bc/proxy/membership/signup-b2b';
    this.customerNameEndpoint = '/apps/indeks-retail-bc/proxy/membership/get-member-name';

    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('.success-message');
    this.errorMessage = this.querySelector('.error-message');
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.type = 'b2c';
    if (this.form.id === 'ir-signup-form-retailer') {
      this.type = 'retailer';
    } else if (this.form.id === 'ir-signup-form-b2b') {
      this.type = 'b2b';
    }

    if (this.type === 'retailer') {
      const urlParams = new URLSearchParams(window.location.search);
      this.memberId = urlParams.get('memberId');
      this.fetchCustomerName(this.memberId);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let endpoint = this.signupEndpoint;
    if (this.type === 'retailer') {
      endpoint = this.signupRetailerEndpoint;
    } else if (this.type === 'b2b') {
      endpoint = this.signupB2bEndpoint;
    }
    const formData = new FormData(this.form);
    const data = Object.fromEntries(formData);
    
    if (this.type === 'b2c') {
      // phone only contains numbers
      if (data.phoneNo && !/^\d+$/.test(data.phoneNo)) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.phone_number_invalid;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
    } else if (this.type === 'retailer') {
      let interests = [];
      this.querySelectorAll('input[name="interests"]').forEach(input => {
        if (input.checked) {
          interests.push(input.value);
        }
      });
      if (interests.length === 0) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.interests_required;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
      data.interests = interests;
      data.memberId = this.memberId;
    } else if (this.type === 'b2b') {
      // postalCode must only contain numbers
      if (data.postalCode && !/^\d+$/.test(data.postalCode)) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.postal_code_invalid;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
      // phone only contains numbers
      if (data.phoneNo && !/^\d+$/.test(data.phoneNo)) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.phone_number_invalid;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
      // CVR and EAN must only contain numbers
      if (data.cvr && !/^\d+$/.test(data.cvr)) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.cvr_invalid;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
      if (data.ean && !/^\d+$/.test(data.ean)) {
        this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.ean_invalid;
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
        }, 200)
        return;
      }
      // data.paymentByCard = !!data.paymentByCard;
    }
    
    // console.log(data);
    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        // if (!response.ok) {
        //   console.log(response)
        //   throw new Error('Network response was not ok');
        // }
        return response.json();
      })
      .then(data => {
        if (data.status === 'success') {
          this.successMessage.classList.remove('hidden');
          this.errorMessage.classList.add('hidden');
          setTimeout(() => {
            this.successMessage.scrollIntoView({ behavior: 'smooth' });
          }, 200)
          // redirect to Shopify login page after 3 seconds
          setTimeout(() => {
            window.location.href = '/account/login';
          }, 3000);
        } else {
          if (data.error.code == 'PhoneNumberExists') {
            this.errorMessage.querySelector('span').innerHTML = window.customSignupFormMessage.phone_existed_html;
          } else if (data.error.code == 'InvalidInput' && data.error.message.includes('Email')) {
            this.errorMessage.querySelector('span').innerHTML = window.customSignupFormMessage.email_existed_html;
          } else if (data.error.code == 'MEMBERSHIP_EXISTS' || data.error.code == 'MembershipExists') {
            this.errorMessage.querySelector('span').innerHTML = window.customSignupFormMessage.email_existed_html;
          } else {
            this.errorMessage.querySelector('span').textContent = window.customSignupFormMessage.error;
          }
          this.errorMessage.classList.remove('hidden');
          this.successMessage.classList.add('hidden');
          setTimeout(() => {
            this.errorMessage.scrollIntoView({ behavior: 'smooth' });
          }, 200)
        }
      })
      .catch(error => {
        console.error('Error:', error);
        this.errorMessage.classList.remove('hidden');
        this.successMessage.classList.add('hidden');
        setTimeout(() => {
          this.errorMessage.scrollIntoView({ behavior: 'smooth' });
        }, 200)
      })
      .finally(() => {
        this.form.querySelector('button[type="submit"]').removeAttribute('aria-busy');
      });
  }

  fetchCustomerName(memberId) {
    fetch(`${this.customerNameEndpoint}?memberId=${memberId}`)
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          let firstName = data.firstName || '';
          let lastName = data.lastName || '';
          if (firstName) {
            this.form.querySelector('input[name="firstName"]').value = firstName;
          }
          if (lastName) {
            this.form.querySelector('input[name="lastName"]').value = lastName;  
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}

customElements.define('ir-signup-form', IrSignupForm);
